<template>
  <!-- 提货派车PickupDispatchCar -->
  <div class="container">
    <el-tabs type="border-card" class="pickup_tab">
      <template v-if="dispatchType === 'shang_men_ti_huo'">
        <el-tab-pane label="提货派车" v-if="permission('list')" >
          <PickupAndDispatchCar ref="pickupDispatchCar" :dispatchType="dispatchType"/>
        </el-tab-pane>
        <el-tab-pane label="派车运单明细" v-if="permission('waybills')">
          <DeliveryWaybillDetails ref="deliveryWaybillDetails" :dispatchType="dispatchType"/>
        </el-tab-pane>
        <el-tab-pane label="派车订单明细" v-if="permission('commands')">
          <DeliveryOrderDetails ref="deliveryOrderDetails" :dispatchType="dispatchType"/>
        </el-tab-pane>
      </template>
      <template v-else>
        <el-tab-pane label="派车单" v-if="permission('list')">
          <PickupAndDispatchCar ref="pickupDispatchCar" :dispatchType="dispatchType"/>
        </el-tab-pane>
        <el-tab-pane label="派车单明细" v-if="permission('waybills')">
          <!-- <DeliveryOrderDetails ref="deliveryWaybillDetails" :dispatchType="dispatchType"/> -->
          <DeliveryWaybillDetails ref="deliveryWaybillDetails" :dispatchType="dispatchType"/>
        </el-tab-pane>
      </template>
    </el-tabs>
  </div>
</template>

<script>
import PickupAndDispatchCar from "./PickupDispatchCar";
import DeliveryWaybillDetails from "./DeliveryWaybillDetails";
import DeliveryOrderDetails from "./DeliveryOrderDetails";
export default {
  components: {
    PickupAndDispatchCar,
    DeliveryWaybillDetails,
    DeliveryOrderDetails,
  },
  props: {
    dispatchType: {},
  },
  computed: {
    host() {
      switch (this.dispatchType) {
        case "shang_men_ti_huo":
          return "shangmentihuo";
        case "gan_xian_pei_zai":
          return "ganxian";
        case "song_huo_shang_men":
          return "songhuoshangmen";
        case "song_chu_wai_fa":
          return "songchuwaifa";
      }
      return "shangmentihuo";
    },
  },
  methods:{
    permission(action){
      return this.hasPermiss('admin:dispatch:'+ this.host +':' + action);
    },
  }
};
</script>

<style scoped lang="less">
.container {
  .pickup_tab {
    /deep/.el-tabs__header {
      .el-tabs__item {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
      }
    }
    /deep/.el-tabs__content {
      padding: 15px 0;
    }
  }
}
</style>